import type { ChainStepStatus, LandStatus } from '@api/replenishment-engine';

/** Keyed by chain-step status, a superset of instrument status, so either indexes it. */
export const STATUS_COLOR: Record<ChainStepStatus, string> = {
    PROPOSED: 'gray',
    SAVED: 'grape',
    APPROVED: 'teal',
    SCHEDULED: 'teal',
    PLACED: 'blue',
    RECEIVED: 'orange',
    CLOSED: 'green',
    CANCELLED: 'red',
    SUPERSEDED: 'gray',
};

export const LAND_LABEL: Record<LandStatus, { text: string; tone: 'red' | 'green' | 'orange' | undefined }> = {
    ON_TIME: { text: 'on time', tone: 'green' },
    LATE_NO_STOCKOUT: { text: 'late, no stockout', tone: 'orange' },
    STOCKOUT: { text: 'stockout', tone: 'red' },
    COVERED: { text: 'covered, nothing to do', tone: 'green' },
    UNSOURCEABLE: { text: 'no route', tone: 'red' },
    NO_DIP: { text: 'no dip, nothing to do', tone: 'green' },
};

export const TYPE_LABEL: Record<string, string> = {
    FG_PO: 'FG order',
    WORK_ORDER: 'Work order',
    MATERIAL_PO: 'Material order',
    TRANSFER: 'Transfer',
};
